import React from 'react';

import { Box, Skeleton, Tooltip, Typography } from '@mui/material';

import { formatNumber } from '~/utils/numberFormatters';

import CompetitorOfferOpportunitiesTooltip from './CompetitorOfferOpportunitiesTooltip';
import { CompetitorOfferRow, describeUserLocations, hasGhaMatch, opportunitiesFrom } from './utils';

interface Props {
  row: CompetitorOfferRow;
}

export default function CompetitorOfferGhaOpportunitiesCell({ row }: Props) {
  const { gha } = row;
  if (!hasGhaMatch(row)) {
    return null;
  }
  if (gha.status !== 'loaded') {
    return gha.status === 'loading' ? <Skeleton width={64} /> : <Typography color="text.secondary">—</Typography>;
  }
  if (!gha.opportunities) {
    return (
      <Tooltip title="The matched hotel had no Google Hotel Ads data in the last 100 days">
        <Typography variant="body2" color="text.secondary">
          N/A
        </Typography>
      </Tooltip>
    );
  }
  const value = opportunitiesFrom(gha.opportunities, row.userLocations);
  const number = (
    <Box textAlign="right" width="100%">
      <Typography variant="body2" fontWeight={value ? 'medium' : undefined}>
        {formatNumber(value)}
      </Typography>
      {row.userLocations.length > 0 && (
        <Typography variant="caption" color="text.secondary">
          {describeUserLocations(row.userLocations)}
        </Typography>
      )}
    </Box>
  );
  if (!gha.opportunities.opportunities) {
    return number;
  }

  return (
    <CompetitorOfferOpportunitiesTooltip
      hotelName={row.hotelName ?? row.externalPropertyId}
      opportunities={gha.opportunities}
      userLocations={row.userLocations}
    >
      {number}
    </CompetitorOfferOpportunitiesTooltip>
  );
}
